.chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: map.get($spacing-scale, 's-1h');
  height: 38px;
  padding: map.get($spacing-scale, 's-1h') map.get($spacing-scale, 's-3');
  border-radius: map.get($radius, 'full');
  white-space: nowrap;

}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.label {
  @include caption-medium;
}

// Type variants
.primary {
  background-color: var(--color-semantic-info);

  .label {
    color: var(--color-neutrals-white);
  }

  .icon {
    color: var(--color-neutrals-white);
  }
}

.text {
  background-color: transparent;

  .label {
    color: var(--color-text-primary);
  }

  .icon {
    color: var(--color-text-primary);
  }
}

.info {
  background-color: var(--color-semantic-container-info);
  border: 1px solid var(--color-semantic-border-info);

  .label {
    color: var(--color-text-primary);
  }

  .icon {
    color: var(--color-text-primary);
  }
}

.warning {
  background-color: var(--color-semantic-container-warning);
  border: 1px solid var(--color-semantic-border-warning);

  .label {
    color: var(--color-text-primary);
  }

  .icon {
    color: var(--color-text-primary);
  }
}

.success {
  background-color: var(--color-semantic-container-success);
  border: 1px solid var(--color-semantic-border-success);

  .label {
    color: var(--color-text-primary);
  }

  .icon {
    color: var(--color-text-primary);
  }
}

.danger {
  background-color: var(--color-semantic-container-danger);
  border: 1px solid var(--color-semantic-border-danger);

  .label {
    color: var(--color-text-primary);
  }

  .icon {
    color: var(--color-text-primary);
  }
}
